module.exports = __webpack_public_path__ + "img/yellowWaterWard.4c8cbdee.svg";